/**
 * Wishlist Global — Shopify
 * Persists product handles in localStorage under key "wishlist_handles"
 * Dispatches custom events: wishlist:added, wishlist:removed, wishlist:updated
 */

window.Wishlist = (() => {
  const KEY = 'wishlist_handles';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  }

  function save(handles) {
    localStorage.setItem(KEY, JSON.stringify(handles));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles } }));
  }

  function add(handle) {
    const handles = getAll();
    if (!handles.includes(handle)) {
      handles.push(handle);
      save(handles);
      document.dispatchEvent(new CustomEvent('wishlist:added', { detail: { handle } }));
    }
  }

  function remove(handle) {
    const handles = getAll().filter(h => h !== handle);
    save(handles);
    document.dispatchEvent(new CustomEvent('wishlist:removed', { detail: { handle } }));
  }

  function toggle(handle) {
    has(handle) ? remove(handle) : add(handle);
  }

  function has(handle) {
    return getAll().includes(handle);
  }

  function count() {
    return getAll().length;
  }

  return { getAll, add, remove, toggle, has, count };
})();


/**
 * Auto-initialise all [data-wishlist-btn] buttons on the page.
 * Usage in liquid:
 *   <button data-wishlist-btn="{{ product.handle }}">♡</button>
 */
document.addEventListener('DOMContentLoaded', () => {
  function syncButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.dataset.wishlistBtn;
      const active = Wishlist.has(handle);
      btn.classList.toggle('wishlist-active', active);
      btn.setAttribute('aria-pressed', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    Wishlist.toggle(btn.dataset.wishlistBtn);
  });

  document.addEventListener('wishlist:updated', syncButtons);
  syncButtons();

  // Keep wishlist count badge up to date (optional)
  // Add an element like <span id="wishlist-count"></span> anywhere in your theme
  function syncCount() {
    const el = document.getElementById('wishlist-count');
    if (el) el.textContent = Wishlist.count();
  }
  document.addEventListener('wishlist:updated', syncCount);
  syncCount();
});